import * as React from 'react';
import { useField } from 'formik';

import StepList from 'security-app/components/SecurityEvents/EventProcedures/plugin/StepList/';
import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';

type Props = {
  field: any & { value: Array<EventProcedureStepAPIType> };
  onMoveList?: (newList: Array<EventProcedureStepAPIType>) => void;
  onViewStep?: (stepId: string) => void;
  onRemoveStep?: (stepId: string) => void;
};

function StepListFormik({ field, onMoveList = undefined, onViewStep = undefined, onRemoveStep = undefined }: Props) {
  const [{ value }, _meta, { setValue, setTouched }] = useField({ name: field.name });

  const handleMoveList = React.useCallback(
    (newList: Array<EventProcedureStepAPIType>) => {
      setValue(newList);
      setTouched(true);
      onMoveList?.(newList);
    },
    [setValue, setTouched, onMoveList],
  );

  const handleRemoveStep = React.useCallback(
    (stepId: string) => {
      value.filter((step: EventProcedureStepAPIType) => step.id !== stepId);
      onRemoveStep?.(stepId);
    },
    [onRemoveStep, value],
  );

  return <StepList steps={value} onMoveList={handleMoveList} onViewStep={onViewStep} onRemoveStep={handleRemoveStep} />;
}

export default StepListFormik;
